import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { insuranceImportService } from "./service";

type InsuranceImport = insuranceImportApiSpec.InsuranceImport;

export const createInsuranceImport = async (idempotencyKey: string) => {
  const { data } = await insuranceImportService.post<InsuranceImport>(
    ``,
    undefined,
    {
      headers: { "Idempotency-Key": idempotencyKey }
    }
  );

  return data;
};
